
function fixColor(color: string) {
  let c = color.trim();
  if (!c.startsWith('#')) return '';
  return c;
}

function generateRendererConfig(boatConfig: BoatConfig, selectedConfig: SelectedConfig, size:'small'|'large'): RendererConfig {
  let pattern = boatConfig.patterns.find((pattern) => pattern.slug === selectedConfig.pattern);
  let middlePattern = boatConfig.middle_patterns.find((pattern) => pattern.slug === selectedConfig.pattern);
  let bottomPattern = boatConfig.bottom_patterns.find((pattern) => pattern.slug === selectedConfig .pattern);
  let topColor = boatConfig.top_colors.find((color) => color.slug === selectedConfig.top_color);
  let middleColor = boatConfig.middle_colors.find((color) => color.slug === selectedConfig.middle_color);
  let bottomColor = boatConfig.bottom_colors.find((color) => color.slug === selectedConfig.bottom_color);
  let texture1 = boatConfig.textures.find((texture) => texture.slug === selectedConfig.texture_1);
  let texture2 = boatConfig.second_textures.find((texture) => texture.slug === selectedConfig.texture_2);

  if (size === 'small') {
    return {
      base: pattern ? pattern.image : '',
      middle_pattern: middlePattern ? middlePattern.image : '',
      bottom_pattern: bottomPattern ? bottomPattern.image : '',
      top_color: topColor ? fixColor(topColor.description) : '',
      top_color_image: topColor ? topColor.image : '',
      middle_color: middleColor ? fixColor(middleColor.description) : '',
      bottom_color: bottomColor ? fixColor(bottomColor.description) : '',
      texture_1: texture1 ? texture1.image : '',
      texture_2: texture2 ? texture2.image : '',
    }
  }
  return {
    base: boatConfig.negative,
    middle_pattern: pattern ? pattern.boat_middle_img : '',
    bottom_pattern: pattern ? pattern.boat_bottom_img : '',
    top_color: topColor ? fixColor(topColor.description) : '',
    top_color_image: topColor ? topColor.image : '',
    middle_color: middleColor ? fixColor(middleColor.description) : '',
    bottom_color: bottomColor ? fixColor(bottomColor.description) : '',
    texture_1: texture1 ? texture1.image : '',
    texture_2: texture2 ? texture2.image : '',
  }
}

function getImageUrlsFromConfig(config: BoatConfig) {
  const list: string[] = [];

  config.patterns.forEach(item => list.push(item.image));
  config.bottom_patterns.forEach(item => list.push(item.image));
  config.patterns.forEach(item => list.push(item.boat_bottom_img));
  config.middle_patterns.forEach(item => list.push(item.image));
  config.patterns.forEach(item => list.push(item.boat_middle_img));
  config.textures.forEach(item => list.push(item.image));
  config.second_textures.forEach(item => list.push(item.image));
  config.top_colors.filter(color => !!color.image_pattern).forEach(item => list.push(item.image));

  return list;
}

export {
  generateRendererConfig,
  getImageUrlsFromConfig
}